export const LaunchState = {
	IDLE: 'idle',
	RUNNING: 'running',
	DONE: 'done',
};
